import { Button } from "@itandi/itandi-bb-ui/Button";
import type { DealConstructionContext } from "~/models/DealConstruction";

type Props = {
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader: DealConstructionContext | null;
	dealEstimationHistoryContext: DealConstructionContext | null;
	handleClickEstimationHistoryPreview: (() => void) | null;
	handleClickEstimationPreview: (() => void) | null;
	ownManagement: boolean;
	width?: "default" | "fill";
};

export function ConstructionDownloadButtons({
	constructionContext,
	dealEstimationHistoryContext,
	dealEstimationDraftHeader,
	handleClickEstimationPreview,
	handleClickEstimationHistoryPreview,
	ownManagement,
	width = "default"
}: Props) {
	const hasConstructions = !!constructionContext.dealConstructions.length;
	const hasDraftConstructions =
		!!dealEstimationDraftHeader?.dealConstructions.length;
	const hasHistoryConstructions =
		!!dealEstimationHistoryContext?.dealConstructions.length;
	const showEstimationHistory = dealEstimationHistoryContext && !ownManagement;

	const handleClickEstimationPreviewDisabled = (() => {
		if (ownManagement && dealEstimationDraftHeader) {
			return !hasDraftConstructions && !hasConstructions;
		}
		return !hasConstructions;
	})();

	return (
		<>
			{handleClickEstimationPreview ? (
				<Button
					disabled={handleClickEstimationPreviewDisabled}
					onClick={handleClickEstimationPreview}
					variant="secondary"
					width={width}
				>
					{showEstimationHistory
						? "申請前見積書ダウンロード"
						: "見積書ダウンロード"}
				</Button>
			) : null}
			{handleClickEstimationHistoryPreview && !ownManagement ? (
				<Button
					disabled={!hasDraftConstructions && !hasHistoryConstructions}
					onClick={handleClickEstimationHistoryPreview}
					variant="secondary"
					width={width}
				>
					{dealEstimationHistoryContext
						? "申請後見積書ダウンロード"
						: "見積書ダウンロード"}
				</Button>
			) : null}
		</>
	);
}
